import './locales/moment.js';
import './elements/parsley-config.js';
import './elements/pikaday-defaults.js';
import './elements/object-fit.js';
import './elements/address-bar-height-compensator.js';
import './elements/menuAim.js';
import './elements/navigation--disable-scroll.js';
import './elements/navigation--disable-link-touch.js';
import './elements/navigation--main-sub-height.js';
import './elements/navigation--item-state.js';
import './elements/top-bar__triggers.js';
import './elements/section--parallax.js';
import './elements/accommodation__inpage-nav.js';
import './elements/accommodation__to-programs.js';
import './elements/accommodation__toggle-program.js';
import './elements/tabs.js';
import './elements/input--label-floating.js';
import './elements/input--date.js';
import './elements/parsley-i18n.js';
import './elements/powermail.js';
import './elements/product-teaser__close.js';
import './elements/autoSizr.js';
import './elements/shard.js';
import './elements/collapse.js';
import './elements/statistic';

window.Fit = window.Fit || {};

// The local country cookie has been accidentially set by the polymer-cookie component. Attemp to remove this. Can probably be removed by 2016-04-01
document.cookie="country=deleted;Expires=Thu, 01-Jan-1970 00:00:01 GMT";

document.dispatchEvent(new CustomEvent('libs-loaded'));
